<template>
  <div class="receive-order-settings-one">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="所属社区">{{info.community}}</a-form-model-item>
      <a-form-model-item label="房间号">{{info.houses_tree_branch}}</a-form-model-item>
      <a-form-model-item label="应收金额">{{info.price}}</a-form-model-item>
      <a-form-model-item label="已收金额" prop="price">
        <a-input-number v-model="form.price" placeholder="请输入实收金额" :min="0" allow-clear></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="缴费方式" prop="type">
        <a-select v-model="form.type" placeholder="请选择缴费方式">
          <a-select-option :value="1">{{receiveOrderPayStatusText(1)}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="缴费人员" prop="people">
        <a-input v-model="form.people" placeholder="请输入缴费人员" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="content">
        <a-textarea v-model="form.content" placeholder="请输入备注"></a-textarea>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import {
    receiveOrderPayStatusText
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import ExpendService from '@/io/expend.js';

  export default {
    name: 'ReceiveOrderSettingsOne',
    props: {
      id: {
        type: Number,
        default() {
          return null
        }
      }
    },
    data() {
      return {
        receiveOrderPayStatusText,
        info: {},
        communityOptions: [],
        form: {
          price: null,
          type: [],
          people: null,
          content: null
        },
        rules: {
          price: [
            {
              required: true,
              message: '请输入实收金额'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择缴费方式'
            }
          ],
          people: [
            {
              required: true,
              message: '请输入缴费人员'
            }
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true
      },
    },
    methods: {
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initPage() {
        if (this.id) {
          ExpendService.orderInfo(this.id).then(res => {
            this.info = {
              ...res,
              community: this.communityOptions.filter(val => val.id === res.community_id)[0].name
            };
            this.form.price = res.pay_price;
            this.form.type = res.pay_type || [];
            this.form.people = res.pay_name;
            this.form.content = res.remark;
          }).catch(err => {});
        }
      },
      submit(callback = () => {}) {
        this.$beforeFormSubmit(this.$refs.form, () => {
          ExpendService.orderSettingsTwo(
            this.id,
            this.form.price,
            this.form.type,
            this.form.people,
            this.form.content
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              callback();
            });
          }).catch(err => {});
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  
</style>